var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-definition-selector-root"},[_c('light-user-definition-dialog',{ref:"selector"}),_vm._v(" "),_c('institution-select-dialog',{ref:"institutionSelectDialog"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }